import { render, staticRenderFns } from "./dialog-consent-mohpromt.vue?vue&type=template&id=d29007f4&"
import script from "./dialog-consent-mohpromt.vue?vue&type=script&lang=js&"
export * from "./dialog-consent-mohpromt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports